import { Image } from 'expo-image';
import type { ImageProps } from 'expo-image';
import { StyleSheet } from 'react-native';

interface ConfirmHeaderOverlayProps {
  backgroundColor?: string;
  source: ImageProps['source'];
}

export const ConfirmHeaderOverlay = ({ source }: ConfirmHeaderOverlayProps) => (
  <Image
    pointerEvents="none"
    source={source}
    style={styles.overlay}
    testID="dragonball-confirm-header-overlay"
  />
);

const styles = StyleSheet.create({
  overlay: StyleSheet.absoluteFillObject,
});
